// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31riN","right":"styles_right__3f4br"};